import {
	GetBankLinkingSessionStatusParams,
	getBankLinkingSessionStatus,
} from "@/api/bank-linking";
import { useQuery } from "@tanstack/react-query";

export function bankLinkingSessionStatusQueryKey(
	params: GetBankLinkingSessionStatusParams,
) {
	return ["bank-linking-session-status", params];
}

export default function useGetBankLinkingSessionStatus(
	params: GetBankLinkingSessionStatusParams,
	options?: { enabled?: boolean },
) {
	return useQuery({
		queryKey: bankLinkingSessionStatusQueryKey(params),
		queryFn: async () => {
			return getBankLinkingSessionStatus(params);
		},
		enabled: options?.enabled ?? true,
		staleTime: Number.POSITIVE_INFINITY,
		gcTime: Number.POSITIVE_INFINITY,
		refetchOnMount: false,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
		retry: false,
	});
}
